<script>
   /**************************************************************/
   /* Svelte component for BiPlot settings                       */
   /**************************************************************/

   import Container from '../../../shared/controls/Container.svelte';
   import Select from '../../../shared/controls/Select.svelte';
   import Range from '../../../shared/controls/Range.svelte';

   export let params;
   export let res;

   let comp1 = 1;
   let comp2 = res && res.ncomp > 1 ? 2 : 1;
   let showLabels = 'hide';
   let axesScale = 'normal';


   $: params = {
      comp: [comp1, comp2],
      showLabels,
      axesScale,
   }
</script>

{#if res  }
<Container label="">
   <p class="title">Biplot</p>
</Container>

<Container label='PC (y-axis):'>
   <Range id='comp2' bind:value={comp2} min={1} max={res.ncomp} step={1} decNum={0} discrete={true} />
</Container>
<Container label='PC (x-axis):'>
   <Range id='comp1' bind:value={comp1} min={1} max={res.ncomp} step={1} decNum={0} discrete={true} />
</Container>
<Container label='Labels:'>
   <Select id='showLabels' bind:value={showLabels} options={['hide', 'obj', 'var', 'both']} />
</Container>
<Container label='Axes:'>
   <Select id='axesScale' bind:value={axesScale} options={['normal', 'equal']} />
</Container>
{/if}

